import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

import { toFormData } from '@platform/shared/utilities/file-utility';

import { DocumentUploadHistoryDto } from '@apps/fiduciary/cockpit/inbox-upload-history/inbox-upload-history.model';
import { InboxDto } from './inbox.model';

@Injectable({
  providedIn: 'root',
})
export class InboxService {
  constructor(private http: HttpClient) {}

  public uploadDocuments(customerSpaceId: string, files: FileList, inbox: InboxDto): Observable<unknown> {
    const formData = toFormData(files);

    return this.http.post(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/fiduciary/inboxes/${inbox}`, formData);
  }

  public downloadDocument(customerSpaceId: string, inbox: InboxDto, fileName: string): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/fiduciary/inboxes/${inbox}/${fileName}`, {
      responseType: 'blob',
    });
  }

  public loadInboxUploadHistory(customerSpaceId: string, inbox: InboxDto): Observable<DocumentUploadHistoryDto[]> {
    return this.http.get<DocumentUploadHistoryDto[]>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/fiduciary/inboxes/${inbox}`);
  }
}
